import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { fromJS } from 'immutable';
import cn from 'classnames'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Typography from '@material-ui/core/Typography'

const countryOptions = [
    {
        displayKey: 'fr',
        value: 'fr'
    },
    {
        displayKey: 'it',
        value: 'it'
    },
    {
        displayKey: 'us',
        value: 'us'
    },
    {
        displayKey: 'au',
        value: 'au'
    },
    {
        displayKey: 'es',
        value: 'es'
    },
    {
        displayKey: 'others',
        value: 'others'
    },
]
const colorOptions = [
    {
        bgcolor: '#e74c39',
        value: 'red'
    },
    {
        bgcolor: '#47c0bb', 
        value: 'white'
    },
    {
        bgcolor: '#ffa3c3',
        value: 'rose'
    },
    {
        bgcolor: 'transfer',
        displayKey: 'filter_others',
        value: 'others'
    },
]
const styleOptions = [
    {
        displayKey: 'wine_type_still',
        value: 'still'
    },
    {
        displayKey: 'wine_type_sparkling',
        value: 'sparkling'
    },
    {
        displayKey: 'wine_type_fortified',
        value: 'fortified'
    },
    {
        displayKey: 'wine_type_dessert',
        value: 'dessert'
    },
]
const volumeOptions = [
    {
        value: 187,
    },
    {
        value: 375,
    },
    {
        value: 500,
    },
    {
        value: 750,
    },
    {
        value: 1500,
    },
    {
        value: 3000,
    },
]

class WineFilter extends Component {
    constructor(props){
        super(props)
        this.defaultValues = {
            country: fromJS([]), // 國家
            minVintage: '', // 年份 最小
            maxVintage: '', // 年份 最大
            isIncludeNV: true,
            color: fromJS([]), // red / white / rose / others
            style: fromJS([]), // still / sparkling / fortified / dessert
            minValue: '', // 市場估值 最小
            maxValue: '', // 市場估值 最大
            volume: fromJS([]), // 容量
        }
        this.state = {
            ...this.defaultValues
        }
    }

    handleOnReset = () => {
        this.setState({
            ...this.defaultValues
        }, () => {
            this.onTriger()
        })
    }

    onTriger = () => {
        const {
            country,
            minVintage,
            maxVintage,
            isIncludeNV,
            color,
            style,
            minValue,
            maxValue,
            volume,
        } = this.state

        const query = {
            country: country.join(','),
            minVintage,
            maxVintage,
            isIncludeNV: isIncludeNV ? 1 : 0 , // 1: yes / 0: no
            color: color.join(','),
            style: style.join(','),
            minValue,
            maxValue,
            volume: volume.join(','),
        }
        
        this.props.onChange(query)
    }

    onInputChange = (event) => {
        // TODO: check positive number and "e" ?
        const field = event.currentTarget.dataset.field
        const value = event.currentTarget.value
        this.setState({
            [field]: parseInt(value, 10),
        })
    }

    onCheckBoxChange = (event, checked) => {
        const field = event.currentTarget.dataset.field
        this.setState({
            [field]: checked
        })
    }

    onMultiSelectChange = (event) => {
        const selectedValue = event.currentTarget.value
        const field = event.currentTarget.dataset.field

        this.setState(prevState => {
            // add
            if(prevState[field].indexOf(selectedValue) === -1){ 
                return { 
                    [field]: prevState[field].push(selectedValue)
                }
            // remove
            } else { 
                return {
                    [field]: prevState[field].filter(c => c !== selectedValue)
                }
            }
        })
    }

    render(){
        const { t, summary } = this.props
        const {
            country,
            minVintage,
            maxVintage,
            isIncludeNV,
            color,
            style,
            minValue,
            maxValue,
            volume,
        } = this.state

        return (
            <Grid container className="wine-filter" style={{ padding: '16px 24px', backgroundColor: 'white' }}>
                <Typography variant="h6" align="center">{t('filter_wine_list')}</Typography>
                {/* 國家 */}
                <Grid container style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('country')}</Typography>
                </Grid>
                <Grid container style={{ marginBottom: '30px' }} spacing={1}>
                    {countryOptions.map(c =>
                        <Grid key={`country_option_${c.displayKey}`} item md={4}>
                            <Button
                                fullWidth
                                variant={country.indexOf(c.value) === -1 ? 'outlined': 'contained'}
                                color={country.indexOf(c.value) === -1 ? 'default': 'primary'}
                                onClick={this.onMultiSelectChange}
                                value={c.value}
                                data-field="country"
                            >
                                {t(`country_${c.displayKey}`)}
                            </Button>
                        </Grid>
                    )}
                </Grid>

                {/* 年份 */}
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('vintage')}{t('vintage_tip')}</Typography>
                </Grid>
                <Grid container alignItems="center">
                    <Grid item md={5}>
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            value={minVintage}
                            placeholder={summary.vintages[0]}
                            onChange={this.onInputChange}
                            inputProps={{
                                'data-field': 'minVintage'
                            }}
                        />
                    </Grid>
                    <Grid item md={2} style={{ textAlign: 'center' }}>－</Grid>
                    <Grid item md={5}>
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            value={maxVintage}
                            placeholder={summary.vintages[summary.vintages.length-1]}
                            onChange={this.onInputChange}
                            inputProps={{
                                'data-field': 'maxVintage'
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container style={{ marginBottom: '30px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                onChange={this.onCheckBoxChange}
                                checked={isIncludeNV}
                                inputProps={{
                                    'data-field': 'isIncludeNV'
                                }}
                            />
                        }
                        label={<span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>N.V</span>}
                    />
                </Grid>

                {/* 酒顏色 */}
                <Grid container style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('wine_color')}</Typography>
                </Grid>
                <Grid container style={{ marginBottom: '30px' }}>
                    {colorOptions.map(c =>
                        <Button
                            key={c.value}
                            className={cn("wine-color pointer",{
                                'actived-wine': color.indexOf(c.value) > -1
                            })}
                            data-field="color"
                            value={c.value}
                            onClick={this.onMultiSelectChange}
                            style={{
                                backgroundColor: c.bgcolor
                            }}
                        >
                            {!!c.displayKey ? t(`${c.displayKey}`) : ""}
                        </Button>
                    )}
                </Grid>
                
                {/* 酒種 */}
                <Grid container justify="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('wine_type')}</Typography>
                </Grid>
                <Grid container style={{ marginBottom: '30px' }} spacing={2}>
                    {styleOptions.map(c =>
                        <Grid key={`color_option_${c.displayKey}`} item md={6}>
                            <Button
                                fullWidth
                                variant={style.indexOf(c.value) === -1 ? 'outlined': 'contained'}
                                color={style.indexOf(c.value) === -1 ? 'default': 'primary'}
                                onClick={this.onMultiSelectChange}
                                value={c.value}
                                data-field="style"
                            >
                                {t(`${c.displayKey}`)}
                            </Button>
                        </Grid>
                    )}
                </Grid>

                {/* 市場估值 */}
                <Grid container style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('est_value')}{t('est_value_tip')}</Typography>
                </Grid>
                <Grid container alignItems="center" style={{ marginBottom: '30px' }}>
                    <Grid item md={5}>
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            placeholder={t('minimum')}
                            value={minValue}
                            onChange={this.onInputChange}
                            inputProps={{
                                'data-field': 'minValue'
                            }}
                        />
                    </Grid>
                    <Grid item md={2} style={{ textAlign: 'center' }}>－</Grid>
                    <Grid item md={5}>
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            placeholder={t('maximum')}
                            value={maxValue}
                            onChange={this.onInputChange}
                            inputProps={{
                                'data-field': 'maxValue'
                            }}
                        />
                    </Grid>
                </Grid>

                {/* 容量 */}
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Typography variant="body2" className="text-grey">{t('volume')}</Typography>
                </Grid>
                <Grid container style={{ marginBottom: '30px' }}>
                    {volumeOptions.map((option, idx) => {
                        const isLast = idx === volumeOptions.length - 1
                        const checked = volume.indexOf(`${option.value}`) === -1
                        return (
                            <Grid key={idx} item md={isLast ? 7 : 5} style={{padding: '5px'}}>
                                <Button
                                    fullWidth
                                    variant={checked ? 'outlined': 'contained'}
                                    color={checked ? 'default': 'primary'}
                                    onClick={this.onMultiSelectChange}
                                    value={option.value}
                                    data-field='volume'
                                >
                                    {option.value} ml {isLast && '或以上'}
                                </Button>
                            </Grid>
                        )}
                    )}
                </Grid>

                <Grid container>
                    <Button variant="contained" color="primary" style={{ width: '100%', marginBottom: '10px' }} onClick={this.onTriger}>{t('filter')}</Button>
                    <Button variant="outlined" style={{ width: '100%' }} onClick={this.handleOnReset}>{t('reset')}</Button>
                </Grid>
            </Grid>
        )
    }
}

export default withTranslation()(WineFilter)